import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromHome from '../../state';
import {
  userConnectionError,
  userConnectionLoading,
  userConnectionPageInfo,
  userConnectionUsers
} from '../../state/selectors/user-connections.selector';
import { Observable, Subject } from 'rxjs';
import * as fromRoot from '../../../state';
import {
  followUserConnection,
  unFollowUserConnection
} from '../../state/actions/user-connections.action';
import { skipWhile, takeUntil } from 'rxjs/operators';
import { BetterPageInfoModel } from '../../../shared/data/models/better-page-info.model';
import { FollowUnFollowUserInput } from '../../../shared/data/inputs/follow-un-follow-user.input';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';
import { LightUserStateModel } from '../../state/states/light-user-state.model';

@Component({
  selector: 'anms-user-connection-parent',
  templateUrl: './user-connection-parent.component.html',
  styleUrls: ['./user-connection-parent.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserConnectionParentComponent implements OnInit, OnDestroy {
  unSubscribed$ = new Subject();

  @Input() emptyStateMessage: string;
  @Output() pageScrolled = new EventEmitter();

  @Input() showSearchEmptyView = false;
  @Input() showFollowersEmptyView = true;

  connectionUsers$: Observable<LightUserStateModel[]>;
  currentUser$: Observable<MiniUserModel>;

  connectionPageInfo: BetterPageInfoModel;
  connectionLoading$: Observable<boolean>;
  connectionError$: Observable<string>;

  constructor(private store$: Store<fromHome.State>) {}

  ngOnInit(): void {
    if (this.showSearchEmptyView) {
      this.showFollowersEmptyView = false;
    }

    this.connectionUsers$ = this.store$.select(userConnectionUsers);
    this.currentUser$ = this.store$.select(fromRoot.getMe);

    this.connectionLoading$ = this.store$.select(userConnectionLoading);
    this.connectionError$ = this.store$.select(userConnectionError);

    this.store$
      .select(userConnectionPageInfo)
      .pipe(
        takeUntil(this.unSubscribed$),
        skipWhile(page => !page)
      )
      .subscribe(pageInfo => (this.connectionPageInfo = pageInfo));
  }

  onScroll(): void {
    if (this.connectionPageInfo && this.connectionPageInfo.hasNextPage) {
      this.pageScrolled.emit();
    }
  }

  followUser(input: FollowUnFollowUserInput): void {
    this.store$.dispatch(
      followUserConnection({
        payload: input
      })
    );
  }

  unFollowUser(input: FollowUnFollowUserInput): void {
    this.store$.dispatch(
      unFollowUserConnection({
        payload: input
      })
    );
  }

  ngOnDestroy(): void {
    this.unSubscribed$.next();
    this.unSubscribed$.complete();
  }
}
